import { render, staticRenderFns } from "./UserExtracts.vue?vue&type=template&id=5f237c6f&"
import script from "./UserExtracts.vue?vue&type=script&lang=js&"
export * from "./UserExtracts.vue?vue&type=script&lang=js&"
import style0 from "./UserExtracts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports